import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyCe7ZmPsBl89c9Vs5w8hA3FRYOtvYp_448",
  authDomain: "dirliquidaciones-e2021.firebaseapp.com",
  projectId: "dirliquidaciones-e2021",
  storageBucket: "dirliquidaciones-e2021.appspot.com",
  messagingSenderId: "899706925748",
  appId: "1:899706925748:web:3b2446aab61bd99e1e1de1"
};

firebase.initializeApp(config);

export const auth      = firebase.auth();
export const firestore = firebase.firestore();
export const storage   = firebase.storage();
export default firebase;